/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootAliases {
  CALLBACK_FRAGMENT = 'callback-fragment',
  CONF_USUARIO_NOVA_SENHA_FRAGMENT = 'conf-usuario-nova-senha-fragment',
  CONF_USUARIO_NOVA_SENHA_ROUTE = 'conf-usuario-nova-senha-route',
  CONFIRMAR_USUARIO_FALHA_FRAGMENT = 'confirmar-usuario-falha-fragment',
  CONFIRMAR_USUARIO_FALHA_ROUTE = 'confirmar-usuario-falha-route',
  CONFIRMAR_USUARIO_FRAGMENT = 'confirmar-usuario-fragment',
  CONFIRMAR_USUARIO_ROUTE = 'confirmar-usuario-route',
  FORGOT_PW_FRAGMENT = 'forgot-pw-fragment',
  FORGOT_PW_ROUTE = 'forgot-pw-route',
  FRAGMENT_CHANGE_PW = 'fragment-change-pw',
  FRAGMENT_SSO_ERROR = 'fragment-sso-error',
  INACTIVITY_FRAGMENT = 'inactivity-fragment',
  INACTIVITY_ROUTE = 'inactivity-route',
  LAYOUT_ROOT = 'layout-root',
  LOGIN_FRAGMENT = 'login-fragment',
  LOGIN_ROUTE = 'login-route',
  NEW_PW_FRAGMENT = 'new-pw-fragment',
  NEW_PW_ROUTE = 'new-pw-route',
  PROVIDER_FRAGMENT = 'provider-fragment',
  REDIRECT_FRAGMENT = 'redirect-fragment',
  REDIRECT_ROUTE = 'redirect-route',
  ROUTE_CHANGE_PW = 'route-change-pw',
  ROUTE_PROVIDER = 'route-provider',
  ROUTE_SSO_ERROR = 'route-sso-error',
  SSO_CALLBACK_ROUTE = 'sso-callback-route',
  SSO_FRAGMENT = 'sso-fragment',
  SSO_ROUTE = 'sso-route',
}
export { RootAliases };
